/**
 * Resolve the most specific, human-readable industry/sub-industry label
 * for a project payload returned by GET /api/projects or /api/projects/{id}.
 *
 * Priority:
 *   1. industry_config.sub_industry_name  (e.g., "Refinery", "Pharma — Sterile")
 *   2. industry_config.sub_type_name      (same payload, alternate key)
 *   3. industry_config.sector_name        (e.g., "Oil & Gas", "Life Sciences")
 *   4. Humanised sub_type slug            (e.g., "oil_gas_refinery" → "Oil Gas Refinery")
 *   5. Humanised industry id              (legacy fallback)
 *   6. "—"
 *
 * Pass `{ withSector: false }` to suppress the "Sector · Sub-industry"
 * breadcrumb and return only the leaf label.
 */
export function getProjectIndustryLabel(p, opts = {}) {
  const { withSector = true } = opts;
  const cfg = p?.industry_config || {};
  const humanise = (s) =>
    String(s || "")
      .replace(/[_\-]+/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .trim();

  const subName = cfg.sub_industry_name || cfg.sub_type_name;
  if (subName) {
    const sector = cfg.sector_name || cfg.sector;
    if (
      withSector &&
      sector &&
      sector.toLowerCase() !== String(subName).toLowerCase()
    ) {
      return `${humanise(sector)} · ${subName}`;
    }
    return subName;
  }
  if (cfg.sector_name) return cfg.sector_name;
  if (p?.sub_type) return humanise(p.sub_type);
  if (p?.industry) return humanise(p.industry);
  return "—";
}
